import styled from 'styled-components'
import { colors, measurments } from '../utils/config'

const StyledTexarea = styled.div`
  label,
  span,
  textarea {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${colors.gray700};
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
  }
  textarea {
    resize: vertical;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${colors.gray500};
    border-radius: ${measurments.borderRadius}px;
    font-size: 0.875rem;
    color: ${colors.gray700};
    padding: 0.6rem;
  }
  margin-bottom: 1.6rem;
  &.light {
    label {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
      color: ${colors.gray700};
    }
    span {
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: 400;
      color: ${colors.gray600};
      margin-bottom: 0.25rem;
    }
    textarea {
      font-size: 0.875rem;
      padding: 0.4rem;
    }
  }
`

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  desc?: string
  light?: boolean
}

const Textarea = (props: Props) => {
  const { label, desc, light, ...textAreaProps } = props
  return (
    <StyledTexarea className={`${light ? 'light' : ''}`}>
      {label && <label htmlFor={props.id}>{label}</label>}
      {desc && <span>{desc}</span>}
      <textarea {...textAreaProps} />
    </StyledTexarea>
  )
}

export default Textarea
